import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
function dispatchStorageEvent(key, newValue) {
    window.dispatchEvent(new StorageEvent('storage', {
        key,
        newValue
    }));
}
function setLocalStorageItem(key, value) {
    const stringifiedValue = JSON.stringify(value);
    window.localStorage.setItem(key, stringifiedValue);
    dispatchStorageEvent(key, stringifiedValue);
}
const removeLocalStorageItem = (key)=>{
    window.localStorage.removeItem(key);
    dispatchStorageEvent(key, null);
};
const getLocalStorageItem = (key)=>window.localStorage.getItem(key);
function useLocalStorage(key, initialValue) {
    const store = (0, __WEBPACK_EXTERNAL_MODULE_react__.useSyncExternalStore)((callback)=>{
        window.addEventListener('storage', callback);
        return ()=>window.removeEventListener('storage', callback);
    }, ()=>getLocalStorageItem(key));
    const setState = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)((v)=>{
        try {
            const nextState = 'function' == typeof v ? v(JSON.parse(store ?? '')) : v;
            if (null == nextState) removeLocalStorageItem(key);
            else setLocalStorageItem(key, nextState);
        } catch (e) {
            console.warn(e);
        }
    }, [
        key,
        store
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        if (null === getLocalStorageItem(key) && void 0 !== initialValue) setLocalStorageItem(key, initialValue);
    }, [
        key,
        initialValue
    ]);
    return [
        store ? JSON.parse(store) : initialValue,
        setState
    ];
}
export { useLocalStorage };

//# sourceMappingURL=useLocalStorage.js.map